import type { RouteRecordRaw } from 'vue-router'
import { getFirstAccessibleAdminRouteFromStorage } from '@/config/adminNavigation'

const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: () => getFirstAccessibleAdminRouteFromStorage(),
    children: [
      {
        path: 'tenant',
        name: 'admin-tenant',
        component: () => import('@/views/admin/TenantInfo.vue'),
        meta: { title: '租户管理', permission: 'tenant:profile:view' }
      },
      {
        path: 'department',
        name: 'admin-department',
        component: () => import('@/views/admin/DepartmentList.vue'),
        meta: { title: '部门管理', permission: 'org:department:view' }
      },
      {
        path: 'user',
        name: 'admin-user',
        component: () => import('@/views/admin/UserList.vue'),
        meta: { title: '用户管理', permission: 'org:user:view' }
      },
      {
        path: 'audits',
        name: 'audits',
        component: () => import('@/views/admin/AuditList.vue'),
        meta: { title: '审计日志', permission: 'system:audit:view' }
      },
      {
        path: 'roles',
        name: 'admin-roles',
        component: () => import('@/views/admin/RoleList.vue'),
        meta: { title: '角色管理', permission: 'permission:role:view' }
      },
      {
        path: 'permissions',
        name: 'admin-permissions',
        component: () => import('@/views/admin/PermissionAssign.vue'),
        meta: { title: '权限分配', permission: 'permission:role:view' }
      },
      {
        path: 'dict',
        name: 'admin-dict',
        component: () => import('@/views/admin/DictManagement.vue'),
        meta: { title: '字典管理', permission: 'system:dict:view' }
      },
      {
        path: 'positions',
        name: 'admin-positions',
        component: () => import('@/views/admin/PositionManagement.vue'),
        meta: { title: '岗位库管理', permission: 'org:position:view' }
      },
      {
        path: 'department-positions',
        name: 'admin-department-positions',
        component: () => import('@/views/admin/DepartmentPositionManagement.vue'),
        meta: { title: '部门岗位管理', permission: 'org:department_position:view' }
      },
      {
        path: 'squads',
        name: 'admin-squads',
        component: () => import('@/views/admin/SquadManagement.vue'),
        meta: { title: '归属小分队', permission: 'org:squad:view' }
      },
      {
        path: 'tracks',
        name: 'admin-tracks',
        component: () => import('@/views/admin/TrackManagement.vue'),
        meta: { title: '赛道配置', permission: 'org:track:view' }
      },
      {
        path: 'im',
        name: 'admin-im',
        component: () => import('@/views/admin/ImSettings.vue'),
        meta: { title: 'IM 集成', permission: 'integration:im:view' }
      },
      {
        path: 'org-integration',
        name: 'admin-org-integration',
        component: () => import('@/views/admin/OrgIntegration.vue'),
        meta: { title: '组织同步', permission: 'integration:external_directory:view' }
      }
    ]
  }
]

export default adminRoutes
